// Do NOT delete or rearrange any enums in this type as it will affect all
// stored notification settings which store the numeric ordinal in a JSON
export enum BFXNotificationType {
  ACCEPTANCE_NEEDED,
  ACTIVATED,
  ACTIVATING,
  CANCELLED,
  EXPIRED,
  EXPIRING,
  FILLED,
  HOT,
  MODIFIED,
  STREAM_OFF,
  SUSPENDED,
  SUSPENDING,
  TRIGGERED,
  DEAL_FAILURE,
  DEALER_INTERVENTION,
  CLEAR_NOTIFICATION,
  ORDER_ACTION_FAIL,
  TRADE_ACTION_FAIL,
  INTERVENTION_ACTION_FAIL,
  UNLOCK,
  PROFILE,
  // UNSOLICITED
  UNSOLICITED_PAUSE_RESUME,
  // CONNECTION_MONITOR,
  CONNECTION_MONITOR,
  // BMARK NOTIFICATIONS
  BMARK_SOFT_CUT_OFF,
  BMARK_HARD_CUT_OFF,
  BMARK_TRIGGERED,
  BMARK_NEW_ORDERS,
  BMARK_DEAL_FAILURE,
  BMARK_CANCELLED,
  BMARK_MODIFIED,
  BMARK_FILLED,
  EXPORT_IMPORT,
  ALGO_INFLIGHT,
  ALGO_INFLIGHT_FAILED,
  MESSAGE,
  POSITION,
  SESSION_END,
  GENERIC_ERROR,
  UNSOLICITED_CANCEL,
  UNSOLICITED_CANCEL_MIGRATED,
  LIMITALGO_ORDER_ENTERED,
  BMARK_ORDER_ENTERED,
  PART_FILLED,
  NETTING_FAILED,

  // These are Algo-specific value used for settings - these constants are not used outside of settings
  // and the notification service which will map more general setting into algo lookup if needed
  ALGO_ACCEPTANCE_NEEDED,
  ALGO_ACTIVATED,
  ALGO_ACTIVATING,
  ALGO_CANCELLED,
  ALGO_DEAL_FAILURE,
  ALGO_EXPIRED,
  ALGO_EXPIRING,
  ALGO_LIMITALGO_ORDER_ENTERED,
  ALGO_FILLED,
  ALGO_MODIFIED,
  ALGO_PART_FILLED,
  ALGO_UNSOLICITED_CANCEL,
  ALGO_UNSOLICITED_CANCEL_MIGRATED,
  ALGO_UNSOLICITED_PAUSE_RESUME,
}

export const BMARK_POPUP_NOTIFICATION_LIST: BFXNotificationType[] = [
  BFXNotificationType.BMARK_ORDER_ENTERED,
  BFXNotificationType.BMARK_SOFT_CUT_OFF,
  BFXNotificationType.BMARK_HARD_CUT_OFF,
  BFXNotificationType.BMARK_TRIGGERED,
  BFXNotificationType.BMARK_NEW_ORDERS,
  BFXNotificationType.BMARK_DEAL_FAILURE,
  BFXNotificationType.BMARK_CANCELLED,
  BFXNotificationType.UNSOLICITED_CANCEL,
  BFXNotificationType.BMARK_MODIFIED,
  BFXNotificationType.BMARK_FILLED,
];
